<div class="wd-100">
    <div class="dialog-header flex_sb p-l-25  m-t-20 p-r-20">
      <div class="fs-15 fw-600">
        {{'SHARED.PINE_LAB_STEPS' | fallbackTranslate}}
      </div>
      <div class="dialog-header-cross flex-center" (click)="cancelClicked()">
        <img [src]="images.CROSS" class="img-20" alt="close" />
      </div>
    </div>

    <div class="staff-guide-body">
    <div *ngFor="let item of staffGuideData; let i = index" class="m-t-10  p-l-25  p-r-25">
        <div class="fw-800 p-r-5">{{'SHARED.STEP' | fallbackTranslate}} {{i+1}}</div>  
        <div [innerHTML]="sanitizeHtml(item?.text)" class="m-b-5"></div>  
        <div><img [src]="item.image" alt="image"/> </div>   
    </div>
    </div> 
</div>